const FORM_POSITION = {start: 'start', end: 'end'};

export default FORM_POSITION;